// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { fileDrawer16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-file-drawer': IconFileDrawer;
    }
}

/**
 * The icon component for the 'fileDrawer' icon
 */
export class IconFileDrawer extends Icon {
    public constructor() {
        super(fileDrawer16X16);
    }
}

registerIcon('icon-file-drawer', IconFileDrawer);
export const iconFileDrawerTag = 'nimble-icon-file-drawer';
